/**
 * @generated SignedSource<<b9b23af62bca0d30ac27d96076810629>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type NavSectionKind = "custom" | "products" | "%future added value";
export type ChannelsSidebarQuery$variables = Record<PropertyKey, never>;
export type ChannelsSidebarQuery$data = {
  readonly channelsSidebarCommunityNavSections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: NavSectionKind;
        readonly " $fragmentSpreads": FragmentRefs<"ChannelsNavSectionFragment">;
      };
    }>;
  };
  readonly channelsSidebarProductNavSections: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
        readonly kind: NavSectionKind;
        readonly " $fragmentSpreads": FragmentRefs<"ChannelsNavSectionFragment">;
      };
    }>;
  };
  readonly isViewerInAnyChannels: boolean;
  readonly " $fragmentSpreads": FragmentRefs<"ChannelsAppsSidebarList_OrganizationPaginationFragment" | "ChannelsProductsSidebarList_OrganizationPaginationFragment">;
};
export type ChannelsSidebarQuery = {
  response: ChannelsSidebarQuery$data;
  variables: ChannelsSidebarQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "isViewerInAnyChannels",
  "storageKey": null
},
v1 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "kind",
  "storageKey": null
},
v3 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavSectionNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSection",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "args": null,
            "kind": "FragmentSpread",
            "name": "ChannelsNavSectionFragment"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
],
v4 = [
  {
    "kind": "Literal",
    "name": "first",
    "value": 10
  }
],
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppTitle",
  "storageKey": null
},
v6 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "externalChannelId",
  "storageKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v8 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "viewerPermissions",
  "storageKey": null
},
v9 = [
  (v8/*: any*/)
],
v10 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "memberPermissions",
  "storageKey": null
},
v11 = [
  {
    "alias": "nonNullProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v8/*: any*/),
  (v10/*: any*/)
],
v12 = [
  {
    "alias": "nullableProductId",
    "args": null,
    "kind": "ScalarField",
    "name": "productId",
    "storageKey": null
  },
  (v8/*: any*/),
  (v10/*: any*/)
],
v13 = {
  "kind": "InlineFragment",
  "selections": [
    (v7/*: any*/),
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "Organization",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nonNullProductId",
          "args": null,
          "kind": "ScalarField",
          "name": "id",
          "storageKey": null
        },
        (v8/*: any*/),
        (v10/*: any*/)
      ],
      "type": "Product",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v11/*: any*/),
      "type": "Event",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Comment",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Feed",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Post",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": [
        {
          "alias": "nullableProductIdString",
          "args": null,
          "kind": "ScalarField",
          "name": "productId",
          "storageKey": null
        },
        (v8/*: any*/),
        (v10/*: any*/)
      ],
      "type": "ContentUsage",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "ChatChannel",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v12/*: any*/),
      "type": "Dashboard",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v11/*: any*/),
      "type": "AssignmentSubmission",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "PathwayGroup",
      "abstractKey": null
    },
    {
      "kind": "InlineFragment",
      "selections": (v9/*: any*/),
      "type": "BrainSearch",
      "abstractKey": null
    }
  ],
  "type": "Node",
  "abstractKey": "__isNode"
},
v14 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "visibility",
  "storageKey": null
},
v15 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "organizationId",
  "storageKey": null
},
v16 = {
  "alias": null,
  "args": null,
  "concreteType": "ChatChannel",
  "kind": "LinkedField",
  "name": "chatChannel",
  "plural": false,
  "selections": [
    (v1/*: any*/),
    (v6/*: any*/),
    (v13/*: any*/),
    (v14/*: any*/),
    (v15/*: any*/)
  ],
  "storageKey": null
},
v17 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "slug",
  "storageKey": null
},
v18 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v19 = [
  (v1/*: any*/)
],
v20 = {
  "alias": null,
  "args": null,
  "concreteType": "ProductMembership",
  "kind": "LinkedField",
  "name": "viewerMembership",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v21 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "product",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v18/*: any*/),
    (v20/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v22 = {
  "alias": null,
  "args": null,
  "concreteType": "Badge",
  "kind": "LinkedField",
  "name": "badge",
  "plural": false,
  "selections": [
    (v2/*: any*/),
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "color",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "icon",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "emoji",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "mediaUrl",
      "storageKey": null
    },
    (v1/*: any*/)
  ],
  "storageKey": null
},
v23 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "productId",
  "storageKey": null
},
v24 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "navSectionId",
  "storageKey": null
},
v25 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "customAppUrl",
  "storageKey": null
},
v26 = {
  "alias": null,
  "args": null,
  "concreteType": "Feed",
  "kind": "LinkedField",
  "name": "feed",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v27 = {
  "alias": null,
  "args": null,
  "concreteType": "Collection",
  "kind": "LinkedField",
  "name": "collection",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v28 = {
  "alias": null,
  "args": null,
  "concreteType": "ContentUsage",
  "kind": "LinkedField",
  "name": "contentUsage",
  "plural": false,
  "selections": (v19/*: any*/),
  "storageKey": null
},
v29 = {
  "alias": null,
  "args": null,
  "concreteType": "Product",
  "kind": "LinkedField",
  "name": "linkProduct",
  "plural": false,
  "selections": [
    (v17/*: any*/),
    (v1/*: any*/)
  ],
  "storageKey": null
},
v30 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "cursor",
  "storageKey": null
},
v31 = {
  "alias": null,
  "args": null,
  "concreteType": "PageInfoObjectType",
  "kind": "LinkedField",
  "name": "pageInfo",
  "plural": false,
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "endCursor",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "hasNextPage",
      "storageKey": null
    }
  ],
  "storageKey": null
},
v32 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductAppNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "ProductApp",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v5/*: any*/),
          (v16/*: any*/),
          (v21/*: any*/),
          (v22/*: any*/),
          (v23/*: any*/),
          (v24/*: any*/),
          (v2/*: any*/),
          (v25/*: any*/),
          (v26/*: any*/),
          (v27/*: any*/),
          (v28/*: any*/),
          (v29/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/)
    ],
    "storageKey": null
  },
  (v31/*: any*/)
],
v33 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "status",
  "storageKey": null
},
v34 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "ProductNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "Product",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v18/*: any*/),
          (v17/*: any*/),
          (v33/*: any*/),
          {
            "alias": null,
            "args": [
              {
                "kind": "Literal",
                "name": "kinds",
                "value": [
                  "chat_channel",
                  "nav_folder"
                ]
              }
            ],
            "concreteType": "ProductAppNodeConnection",
            "kind": "LinkedField",
            "name": "productApps",
            "plural": false,
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": "ProductAppNodeEdge",
                "kind": "LinkedField",
                "name": "edges",
                "plural": true,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "ProductApp",
                    "kind": "LinkedField",
                    "name": "node",
                    "plural": false,
                    "selections": [
                      (v1/*: any*/),
                      (v2/*: any*/),
                      (v5/*: any*/),
                      {
                        "alias": null,
                        "args": [
                          {
                            "kind": "Literal",
                            "name": "kinds",
                            "value": [
                              "chat_channel"
                            ]
                          }
                        ],
                        "concreteType": "ProductAppNodeConnection",
                        "kind": "LinkedField",
                        "name": "productApps",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "ProductAppNodeEdge",
                            "kind": "LinkedField",
                            "name": "edges",
                            "plural": true,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": "ProductApp",
                                "kind": "LinkedField",
                                "name": "node",
                                "plural": false,
                                "selections": [
                                  (v1/*: any*/),
                                  {
                                    "alias": null,
                                    "args": null,
                                    "concreteType": "ChatChannel",
                                    "kind": "LinkedField",
                                    "name": "chatChannel",
                                    "plural": false,
                                    "selections": [
                                      (v6/*: any*/),
                                      (v1/*: any*/),
                                      (v13/*: any*/),
                                      (v14/*: any*/),
                                      (v15/*: any*/)
                                    ],
                                    "storageKey": null
                                  },
                                  (v5/*: any*/),
                                  (v21/*: any*/),
                                  (v22/*: any*/),
                                  (v23/*: any*/),
                                  (v24/*: any*/),
                                  (v2/*: any*/),
                                  (v25/*: any*/),
                                  (v26/*: any*/),
                                  (v27/*: any*/),
                                  (v28/*: any*/),
                                  (v29/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": "productApps(kinds:[\"chat_channel\"])"
                      },
                      (v16/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Product",
                        "kind": "LinkedField",
                        "name": "product",
                        "plural": false,
                        "selections": [
                          (v17/*: any*/),
                          (v18/*: any*/),
                          (v20/*: any*/),
                          (v1/*: any*/),
                          (v13/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "kind": "ScalarField",
                            "name": "type",
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      },
                      (v22/*: any*/),
                      (v23/*: any*/),
                      (v24/*: any*/),
                      (v25/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Feed",
                        "kind": "LinkedField",
                        "name": "feed",
                        "plural": false,
                        "selections": [
                          (v1/*: any*/),
                          (v18/*: any*/)
                        ],
                        "storageKey": null
                      },
                      (v27/*: any*/),
                      (v28/*: any*/),
                      (v29/*: any*/),
                      (v33/*: any*/),
                      (v14/*: any*/),
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": "Dashboard",
                        "kind": "LinkedField",
                        "name": "forYouDashboard",
                        "plural": false,
                        "selections": (v19/*: any*/),
                        "storageKey": null
                      },
                      (v15/*: any*/)
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "storageKey": "productApps(kinds:[\"chat_channel\",\"nav_folder\"])"
          },
          (v22/*: any*/),
          (v7/*: any*/)
        ],
        "storageKey": null
      },
      (v30/*: any*/)
    ],
    "storageKey": null
  },
  (v31/*: any*/)
],
v35 = [
  {
    "alias": null,
    "args": null,
    "concreteType": "NavSectionNodeEdge",
    "kind": "LinkedField",
    "name": "edges",
    "plural": true,
    "selections": [
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSection",
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v1/*: any*/),
          (v2/*: any*/),
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "title",
            "storageKey": null
          },
          {
            "alias": null,
            "args": null,
            "kind": "ScalarField",
            "name": "viewerExternalChannelIds",
            "storageKey": null
          },
          {
            "alias": "apps",
            "args": (v4/*: any*/),
            "concreteType": "ProductAppNodeConnection",
            "kind": "LinkedField",
            "name": "channelsSidebarNavSectionApps",
            "plural": false,
            "selections": (v32/*: any*/),
            "storageKey": "channelsSidebarNavSectionApps(first:10)"
          },
          {
            "alias": "apps",
            "args": (v4/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ChannelsAppsSidebarList_NavSectionPaginationFragment__apps",
            "kind": "LinkedHandle",
            "name": "channelsSidebarNavSectionApps"
          },
          {
            "alias": "products",
            "args": (v4/*: any*/),
            "concreteType": "ProductNodeConnection",
            "kind": "LinkedField",
            "name": "channelsSidebarNavSectionProducts",
            "plural": false,
            "selections": (v34/*: any*/),
            "storageKey": "channelsSidebarNavSectionProducts(first:10)"
          },
          {
            "alias": "products",
            "args": (v4/*: any*/),
            "filters": null,
            "handle": "connection",
            "key": "ChannelsProductsSidebarList_NavSectionPaginationFragment__products",
            "kind": "LinkedHandle",
            "name": "channelsSidebarNavSectionProducts"
          }
        ],
        "storageKey": null
      }
    ],
    "storageKey": null
  }
];
return {
  "fragment": {
    "argumentDefinitions": [],
    "kind": "Fragment",
    "metadata": null,
    "name": "ChannelsSidebarQuery",
    "selections": [
      (v0/*: any*/),
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChannelsAppsSidebarList_OrganizationPaginationFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSectionNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarCommunityNavSections",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      },
      {
        "args": null,
        "kind": "FragmentSpread",
        "name": "ChannelsProductsSidebarList_OrganizationPaginationFragment"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSectionNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarProductNavSections",
        "plural": false,
        "selections": (v3/*: any*/),
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": [],
    "kind": "Operation",
    "name": "ChannelsSidebarQuery",
    "selections": [
      (v0/*: any*/),
      {
        "alias": "topLevelApps",
        "args": (v4/*: any*/),
        "concreteType": "ProductAppNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarTopLevelApps",
        "plural": false,
        "selections": (v32/*: any*/),
        "storageKey": "channelsSidebarTopLevelApps(first:10)"
      },
      {
        "alias": "topLevelApps",
        "args": (v4/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "ChannelsAppsSidebarList_OrganizationPaginationFragment__topLevelApps",
        "kind": "LinkedHandle",
        "name": "channelsSidebarTopLevelApps"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSectionNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarCommunityNavSections",
        "plural": false,
        "selections": (v35/*: any*/),
        "storageKey": null
      },
      {
        "alias": "topLevelProducts",
        "args": (v4/*: any*/),
        "concreteType": "ProductNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarTopLevelProducts",
        "plural": false,
        "selections": (v34/*: any*/),
        "storageKey": "channelsSidebarTopLevelProducts(first:10)"
      },
      {
        "alias": "topLevelProducts",
        "args": (v4/*: any*/),
        "filters": null,
        "handle": "connection",
        "key": "ChannelsProductsSidebarList_OrganizationPaginationFragment__topLevelProducts",
        "kind": "LinkedHandle",
        "name": "channelsSidebarTopLevelProducts"
      },
      {
        "alias": null,
        "args": null,
        "concreteType": "NavSectionNodeConnection",
        "kind": "LinkedField",
        "name": "channelsSidebarProductNavSections",
        "plural": false,
        "selections": (v35/*: any*/),
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "81e6dd07496bfce770c18989807d39d4",
    "id": null,
    "metadata": {},
    "name": "ChannelsSidebarQuery",
    "operationKind": "query",
    "text": "query ChannelsSidebarQuery {\n  isViewerInAnyChannels\n  ...ChannelsAppsSidebarList_OrganizationPaginationFragment\n  channelsSidebarCommunityNavSections {\n    edges {\n      node {\n        id\n        kind\n        ...ChannelsNavSectionFragment\n      }\n    }\n  }\n  ...ChannelsProductsSidebarList_OrganizationPaginationFragment\n  channelsSidebarProductNavSections {\n    edges {\n      node {\n        id\n        kind\n        ...ChannelsNavSectionFragment\n      }\n    }\n  }\n}\n\nfragment AppSidebarItemFragment on ProductApp {\n  kind\n  status\n  visibility\n  customAppTitle\n  badge {\n    ...BadgeFragment\n    id\n  }\n  product {\n    ...usePermissionsFragment\n    id\n  }\n  forYouDashboard {\n    id\n  }\n  ...RemoveAppButtonFragment\n  ...ToggleAppStatusButtonFragment\n}\n\nfragment AppUtils_getLocationFragment on ProductApp {\n  id\n  kind\n  customAppUrl\n  product {\n    slug\n    id\n  }\n  feed {\n    id\n  }\n  chatChannel {\n    id\n  }\n  collection {\n    id\n  }\n  contentUsage {\n    id\n  }\n  linkProduct {\n    slug\n    id\n  }\n}\n\nfragment BadgeFragment on Badge {\n  kind\n  color\n  icon\n  emoji\n  mediaUrl\n}\n\nfragment ChannelsAppsSidebarList_NavSectionPaginationFragment on NavSection {\n  id\n  apps: channelsSidebarNavSectionApps(first: 10) {\n    edges {\n      node {\n        id\n        ...ChatChannelSideBarItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChannelsAppsSidebarList_OrganizationPaginationFragment on Query {\n  topLevelApps: channelsSidebarTopLevelApps(first: 10) {\n    edges {\n      node {\n        id\n        ...ChatChannelSideBarItemFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChannelsNavSectionFragment on NavSection {\n  id\n  kind\n  title\n  viewerExternalChannelIds\n  ...ChannelsAppsSidebarList_NavSectionPaginationFragment\n  ...ChannelsProductsSidebarList_NavSectionPaginationFragment\n}\n\nfragment ChannelsProductsSidebarList_NavSectionPaginationFragment on NavSection {\n  id\n  products: channelsSidebarNavSectionProducts(first: 10) {\n    edges {\n      node {\n        id\n        ...ChannelsSidebarProductFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChannelsProductsSidebarList_OrganizationPaginationFragment on Query {\n  topLevelProducts: channelsSidebarTopLevelProducts(first: 10) {\n    edges {\n      node {\n        id\n        ...ChannelsSidebarProductFragment\n        __typename\n      }\n      cursor\n    }\n    pageInfo {\n      endCursor\n      hasNextPage\n    }\n  }\n}\n\nfragment ChannelsSidebarProductFragment on Product {\n  id\n  name\n  slug\n  status\n  productApps(kinds: [chat_channel, nav_folder]) {\n    edges {\n      node {\n        id\n        kind\n        customAppTitle\n        productApps(kinds: [chat_channel]) {\n          edges {\n            node {\n              id\n              chatChannel {\n                externalChannelId\n                id\n              }\n              ...ChatChannelSideBarItemFragment\n            }\n          }\n        }\n        ...ChatChannelSideBarItemFragment\n        ...AppSidebarItemFragment\n      }\n    }\n  }\n  ...ProductBadgeFragment\n}\n\nfragment ChatChannelBadgeFragment on ProductApp {\n  badge {\n    ...BadgeFragment\n    id\n  }\n  chatChannel {\n    visibility\n    id\n  }\n}\n\nfragment ChatChannelSettingsModalButtonFragment on ProductApp {\n  id\n  productId\n}\n\nfragment ChatChannelSideBarItemFragment on ProductApp {\n  id\n  customAppTitle\n  chatChannel {\n    id\n    externalChannelId\n    ...usePermissionsFragment\n  }\n  product {\n    slug\n    name\n    viewerMembership {\n      id\n    }\n    id\n  }\n  ...ChatChannelBadgeFragment\n  ...ChatChannelSettingsModalButtonFragment\n  ...DeleteChatChannelAppButtonFragment\n  ...AppUtils_getLocationFragment\n}\n\nfragment DeleteChatChannelAppButtonFragment on ProductApp {\n  id\n  navSectionId\n  product {\n    id\n    slug\n  }\n  chatChannel {\n    id\n    organizationId\n  }\n}\n\nfragment ProductBadgeFragment on Product {\n  id\n  badge {\n    ...BadgeFragment\n    id\n  }\n}\n\nfragment RemoveAppButtonFragment on ProductApp {\n  id\n  kind\n  customAppTitle\n  feed {\n    id\n    name\n  }\n  collection {\n    id\n  }\n  productId\n  organizationId\n  navSectionId\n}\n\nfragment ToggleAppStatusButtonFragment on ProductApp {\n  id\n  status\n  kind\n  product {\n    type\n    id\n  }\n}\n\nfragment usePermissionsFragment on Node {\n  __isNode: __typename\n  __typename\n  ... on Organization {\n    viewerPermissions\n  }\n  ... on Product {\n    nonNullProductId: id\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Event {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Comment {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Feed {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Post {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ContentUsage {\n    nullableProductIdString: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on ChatChannel {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on Dashboard {\n    nullableProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on AssignmentSubmission {\n    nonNullProductId: productId\n    viewerPermissions\n    memberPermissions\n  }\n  ... on PathwayGroup {\n    viewerPermissions\n  }\n  ... on BrainSearch {\n    viewerPermissions\n  }\n}\n"
  }
};
})();

(node as any).hash = "1ff26ea50d83c55c84df31e8bf1206b3";

export default node;
